import React from 'react';
import { Icon } from '@chakra-ui/react';
import { MdSpaceDashboard, MdInventory2, MdReceiptLong } from 'react-icons/md';
import { IoMdCart } from 'react-icons/io';
import { FaStore, FaTruck } from 'react-icons/fa';
import { PiShoppingBagFill } from 'react-icons/pi';
import { BiLinkExternal } from 'react-icons/bi';
import { FaChartLine, FaMagic, FaPlusCircle } from 'react-icons/fa';

import MainDashboard from 'views/admin/default';

import SignIn from 'scenes/auth/sign-in';
import ForgotPassword from 'scenes/auth/forgot-password';
import ResetPassword from 'scenes/auth/reset-password';

import Dashboard from 'scenes/dasboard';

import Listings from 'scenes/listings';
import Listing from 'scenes/listings/listing';
import Items from 'scenes/items';

import Stores from 'scenes/stores';
import Store from 'scenes/stores/store';
import StoreSync from 'scenes/stores/store-sync';
import AddStore from 'scenes/stores/add-store';

import Suppliers from 'scenes/suppliers';
import Supplier from 'scenes/suppliers/supplier';
import Inventories from 'scenes/suppliers/inventories';
import InventorySearch from 'scenes/suppliers/inventory-search';

import Marketplaces from 'scenes/marketplaces';

import ThirdPartyIntegrations from 'scenes/third-party-integrations';

import ListingRepricer from 'scenes/listing-repricer';
import ListingOptimizer from 'scenes/listing-optimizer';
import ListingCreation from 'scenes/listing-creation';

import Orders from 'scenes/orders';
import Order from 'scenes/orders/order';

import Profile from 'scenes/profile';

const routes = [
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/dashboard',
    icon: <Icon as={MdSpaceDashboard} width="20px" height="20px" color="inherit" />,
    component: <Dashboard />,
    children: [
      {
        name: 'Example',
        layout: '/admin',
        path: '/example',
        component: <MainDashboard />,
      },
    ],
  },
  {
    name: 'Listings',
    layout: '/admin',
    path: '/listings',
    icon: <Icon as={IoMdCart} width="20px" height="20px" color="inherit" />,
    sidebar: true,
    component: <Listings />,
  },
  {
    name: 'Items',
    layout: '/admin',
    path: '/items',
    icon: <Icon as={MdInventory2} width="20px" height="20px" color="inherit" />,
    sidebar: true,
    component: <Items />,
  },
  {
    name: 'Orders',
    layout: '/admin',
    path: '/orders',
    icon: <Icon as={MdReceiptLong} width="20px" height="20px" color="inherit" />,
    sidebar: true,
    component: <Orders />,
  },
  {
    name: 'Stores',
    layout: '/admin',
    path: '/stores',
    icon: <Icon as={FaStore} width="20px" height="20px" color="inherit" />,
    sidebar: true,
    component: <Stores />,
    children: [
      {
        name: 'Store Sync',
        layout: '/admin',
        path: '/store-sync',
        component: <StoreSync />,
      },
      {
        name: 'Add Store',
        layout: '/admin',
        path: '/add-store',
        component: <AddStore />,
      },
    ],
  },
  {
    name: 'Suppliers',
    layout: '/admin',
    path: '/suppliers',
    icon: <Icon as={FaTruck} width="20px" height="20px" color="inherit" />,
    sidebar: true,
    component: <Suppliers />,
    children: [
      {
        name: 'Inventories',
        layout: '/admin',
        path: '/inventories',
        component: <Inventories />,
      },
      {
        name: 'Inventory Search',
        layout: '/admin',
        path: '/inventory-search',
        component: <InventorySearch />,
      },
    ],
  },
  {
    name: 'Supplier',
    layout: '/admin',
    path: '/supplier/:id',
    sidebar: false,
    component: <Supplier />,
  },
  {
    name: 'Marketplaces',
    layout: '/admin',
    path: '/marketplaces',
    icon: <Icon as={PiShoppingBagFill} width="20px" height="20px" color="inherit" />,
    sidebar: true,
    component: <Marketplaces />,
  },
  {
    name: 'Third Party Integrations',
    layout: '/admin',
    path: '/third-party-integrations',
    icon: <Icon as={BiLinkExternal} width="20px" height="20px" color="inherit" />,
    sidebar: true,
    component: <ThirdPartyIntegrations />,
  },
  {
    name: 'Listing Repricer',
    layout: '/admin',
    path: '/listing-repricer',
    icon: <Icon as={FaChartLine} width="20px" height="20px" color="inherit" />,
    sidebar: true,
    component: <ListingRepricer />,
  },
  {
    name: 'Listing Optimizer',
    layout: '/admin',
    path: '/listing-optimizer',
    icon: <Icon as={FaMagic} width="20px" height="20px" color="inherit" />,
    sidebar: true,
    component: <ListingOptimizer />,
  },
  {
    name: 'Listing Creation',
    layout: '/admin',
    path: '/listing-creation',
    icon: <Icon as={FaPlusCircle} width="20px" height="20px" color="inherit" />,
    sidebar: true,
    component: <ListingCreation />,
  },
  {
    name: 'Store',
    layout: '/admin',
    path: '/stores/:id',
    sidebar: false,
    component: <Store />,
  },
  {
    name: 'Listing',
    layout: '/admin',
    path: '/listings/:id',
    sidebar: false,
    component: <Listing />,
  },
  {
    name: 'Order',
    layout: '/admin',
    path: '/orders/:id',
    sidebar: false,
    component: <Order />,
  },

  {
    name: 'Profile',
    layout: '/admin',
    path: '/profile',
    sidebar: false,
    component: <Profile />,
  },

  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    sidebar: false,
    component: <SignIn />,
  },
  {
    name: 'Forgot Password',
    layout: '/auth',
    path: '/forgot-password',
    sidebar: false,
    component: <ForgotPassword />,
  },
  {
    name: 'Reset Password',
    layout: '/auth',
    path: '/reset-password',
    sidebar: false,
    component: <ResetPassword />,
  },
];

export default routes;
